import Vue from 'vue'
import App from './App.vue'
//import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueI18n from 'vue-i18n'
import Snotify from 'vue-snotify';
import "vue-snotify/styles/simple.css";
import {SnotifyPosition, SnotifyStyle} from 'vue-snotify';
import VuetifyConfirm from 'vuetify-confirm'
import ApiService from './services/api.service'
import TokenService from './services/token.service'
import apiConfig from './static/apiConfig'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)


import moment from 'moment'
import 'moment/locale/ru'  // without this line it didn't work
moment.locale('ru')

ApiService.init(apiConfig.url)

// If token exists set header
if (TokenService.getToken()) {
  ApiService.setHeader()
}

const options = {
  toast: {
    position: SnotifyPosition.centerTop,
  },
  global: {
    maxOnScreen: 1,
    maxAtPosition: 1
  }

}
Vue.use(Snotify, options)
Vue.use(VuetifyConfirm, { vuetify })

Vue.use(TiptapVuetifyPlugin, {
  // the next line is important! You need to provide the Vuetify Object to this place.
  vuetify, // same as "vuetify: vuetify"
  // optional, default to 'md' (default vuetify icons before v2.0.0)
  iconsGroup: 'mdi'
})

Vue.use(VueI18n)
import i18nDictonary from './static/i18n'

const i18n = new VueI18n({
  locale: 'ru', // set locale
  messages: i18nDictonary.messages // set locale messages
})

//console.log('vuetify', vuetify)

vuetify.lang = {
  t: (key, ...params) => i18n.t(key, params),
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
